import AxiosClient from "../../../services/axios.services";

class PurposeServices {
  getPurpose = (params) =>
    AxiosClient.get("/api/app/descriptor_perfil_proposito/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getPurposeById = (id) =>
    AxiosClient.get(`/api/app/descriptor_perfil_proposito/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });

  savePurpose = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_proposito/", data, {
      headers: { "Content-Type": "application/json" },
    });

  editPurpose = (id, data) =>
    AxiosClient.put(`/api/app/descriptor_perfil_proposito/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });

  deletePurpose = (id) =>
    AxiosClient.delete(`/api/app/descriptor_perfil_proposito/${id}`, {
      headers: { "Content-Type": "aplication/json" },
    });
}

export default new PurposeServices();
